import * as React from "react";
import {
  Grid,
  Typography,
  Button,
  IconButton,
  Box,
  Avatar,
  useMediaQuery,
  Chip
} from "@mui/material";
import images from "assets/images/images";
import { colors } from "../../../styles/colors";
import { statusMapping } from "utils/constants";
import theme from "styles/theme";
import { useHistory, useParams } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import HorizontalDivider from "app/components/HorizontalDivider";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MESRequiredTag from "app/components/MESRequiredTag";

interface JobInfoProps {
  job: any;
  refetch: any;
  socialShareModelOpen: any;
  setSocialShareModelOpen: any;
  update_job_status: any;
  delete_job: any;
}

const JobInfo = (props: JobInfoProps) => {
  const { setSocialShareModelOpen, update_job_status, delete_job } = props;
  const { job_id }: any = useParams();
  const history = useHistory();
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const matchesSmallScreens = useMediaQuery("(max-width: 1200px)");

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid container 
        justifyContent="space-between" 
        alignItems="flex-start"
        sx={{
          flexWrap: matchesSmallScreens ? "wrap" : "nowrap"
        }}>
        <Grid item sx={{ 
          display: "flex", 
          alignItems: "start",
          minWidth: 0,
          width: matchesSmallScreens ? "100%" : "auto",
          maxWidth: matchesSmallScreens ? "100%" : "65%",
          overflow: "hidden"
        }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box>
              {props?.job?.job?.organization_logo ? (
                <Avatar sx={{ height: 50, width: 50 }}>
                  <img
                    src={props?.job?.job?.organization_logo}
                    alt="logo"
                    height={50}
                    width={50}
                  />
                </Avatar>
              ):(
                <Avatar
                  sx={{
                    height: 50,
                    width: 50,
                    backgroundColor: colors.primaryBlue
                  }}
                >
                  {props?.job?.job?.title ? props?.job?.job?.title.charAt(0) : ""}
                </Avatar>
              )}
            </Box>
            <Box sx={{ ml: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'start' }}>
                <Typography
                  fontSize="24px"
                  fontWeight={600}
                  color={`${colors.primaryBlue}E5`}
                  sx={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    lineHeight: 1.2,
                    marginRight: props?.job?.job?.mes_required ? 4 : 0
                  }}
                >
                  {props?.job?.job?.title}
                </Typography>
                {props?.job?.job?.mes_required && <MESRequiredTag />}
              </Box>
              <Typography fontSize="14px" color={colors.fontLight}>
                {props?.job?.job?.created_by?.organization?.name || ""}
              </Typography>
              <Typography  sx={{color:colors.fontDarkBlue, fontSize: {xs: "14px", lg: "16px"}, fontWeight: 600, fontStyle: 'italic' }}>
                {props?.job?.job?.job_type === "JOB" ? "Job" : "Internship"}
                {
                  props?.job?.job?.external_job_id
                    ? ` from ${
                        props?.job?.job?.external_source === "hyre"
                          ? "Hyre 2.0"
                          : (props?.job?.job?.external_source
                              ? props?.job?.job?.external_source.charAt(0).toUpperCase() + props?.job?.job?.external_source.slice(1)
                              : "")
                      }`
                    : ""
                }
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", ml: { xs: 0, sm: 2, md: 3 }, mt: 0 }}>
            <Chip
              label={
                <Typography fontSize={15}>
                  {statusMapping[props?.job?.job?.status || 0]}
                </Typography>
              }
              sx={{
                backgroundColor:
                  props?.job?.job?.status === 21
                    ? colors.chipYellow
                    : props?.job?.job?.status === 16
                    ? colors.danger
                    : props?.job?.job?.status === 22
                    ? colors.chipTealGreen
                    : props?.job?.job?.status === 1
                    ? colors.chipGreen
                    : props?.job?.job?.status === 17
                    ? colors.chipViolet
                    : colors.chipYellow,
                color: colors.secondary,
                borderRadius: "50px",
                px: 1.5,
                mr: 2
              }}
            />

            {/* <Chip
              label={
                <Typography fontSize={15}>
                  {" "}
                  {props?.job?.job?.job_type === "JOB" ? "Job" : "Internship"}
                </Typography>
              }
              sx={{
                backgroundColor:
                  props?.job?.job?.job_type === "JOB"
                    ? colors.chipBlue
                    : colors.chipOrange,
                color: colors.secondary,
                borderRadius: "50px",
                px: 1.5,
                mr: 2
              }}
            /> */}
          </Box>
        </Grid>
        <Grid
          item
          lg={4}
          md={5}
          sm={6}
          xs={12}
          sx={{
            display: matchesXs ? "none" : "flex",
            justifyContent: matchesSmallScreens ? "flex-start" : "end",
            alignItems: "flex-start",
            alignSelf: "flex-start",
            gap: { xs: 1, sm: 1.5, md: 2 },
            mt: matchesSmallScreens ? 2 : 0,
            minWidth: 0,
            width: matchesSmallScreens ? "100%" : "auto"
          }}
        >
          <Chip
            label={
              <Typography fontSize={15}>{`(${
                props?.job?.job?.number_of_views || 0
              } Views)`}</Typography>
            }
            sx={{
              backgroundColor: colors.lightBlueChip,
              color: colors.primaryBlue,
              borderRadius: "50px",
              px: 1.5
            }}
          />
          <Button
            variant="outlined"
            sx={{
              color: colors.secondary,
              backgroundColor: colors.primaryBlue,
              width: "130px",
              borderRadius: "1px",
              "&:hover": {
                backgroundColor: colors.primaryBlueDark,
                color: colors.secondary
              }
            }}
            onClick={() => {
              // history.push(`/employer-job-appliedcanditate/${job_id}`);
              history.push({
                pathname: `/employer-job-appliedcanditate/${job_id}`,
                state: { job_title: props?.job?.job?.title }
              });
            }}
          >
            Applicants
          </Button>
          <Box sx={{ ml: 1 }}>
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleClick}
              sx={{ color: colors.primaryBlue, fontSize: 26 }}
            >
              <MoreVertIcon color="inherit" fontSize="inherit" />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button"
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  width: "auto"
                }
              }}
            >
              {props?.job?.job?.status === 0 && (
                <>
                  <MenuItem
                    onClick={() => {
                      history.push(`/employer-add-job/${props?.job?.job?.id}`);
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: "18px",
                        color: colors.primaryBlue,
                        display: "flex"
                      }}
                    >
                      <BorderColorOutlinedIcon
                        fontSize="inherit"
                        color="inherit"
                        sx={{ marginRight: "12px" }}
                      />
                    </Box>
                    Edit Details
                  </MenuItem>
                  <HorizontalDivider />
                </>
              )}
              {props?.job?.job?.status == 1 && props?.job?.job?.publish_to?.toLowerCase?.() == "everyone" && <>
                <MenuItem
                  onClick={() => {
                    setSocialShareModelOpen(true);
                    handleClose();
                  }}
                  disabled={
                    props?.job?.job?.status === 0 ||
                    props?.job?.job?.status === 16
                      ? true
                      : false
                  }
                >
                  <img
                    src={images.share_icon_blue}
                    width={16}
                    style={{ marginRight: "12px" }}
                  />
                  Share
                </MenuItem>
              </>}
              <>
                <MenuItem
                  sx={{ my: 0.5 }}
                  onClick={() => {
                    history.push("/employer-add-job/new", {
                      job_id: props?.job?.job?.id
                    });
                  }}
                >
                  <ContentCopyIcon
                    style={{ fontSize: 19, color: colors.primaryBlue }}
                  />
                  <Typography fontSize={14} color={colors.fontPrimary} ml={1.7}>
                    Copy
                  </Typography>
                </MenuItem>
                <HorizontalDivider />
              </>
              {/* {(props?.job?.job?.status === 21 || props?.job?.job?.status === 22) && (
              <>
                <MenuItem
                  sx={{ my: 0.5 }}
                  onClick={() => {
                    setSelectedJob(data);
                    setRefreshJobModalOpen(true);
                    handleClose();
                  }}
                >
                  <img src={images.refresh_icon_blue} width={17} />
                  <Typography fontSize={14} color={colors.fontPrimary} ml={2}>
                    Refresh
                  </Typography>
                </MenuItem>
                <HorizontalDivider />
              </>
            )} */}
              {props?.job?.job?.status !== 0 &&
                props?.job?.job?.status !== 16 &&
                props?.job?.job?.status !== 22 && (
                  <>
                    <MenuItem
                      sx={{ my: 0.5 }}
                      onClick={() => {
                        update_job_status({
                          variables: {
                            input: {
                              id: props?.job?.job?.id,
                              status: 16
                            }
                          }
                        });
                        handleClose();
                      }}
                    >
                      <img src={images.close_icon_blue} width={21} />
                      <Typography
                        fontSize={14}
                        color={colors.fontPrimary}
                        ml={1.4}
                      >
                        Close
                      </Typography>
                    </MenuItem>
                    <HorizontalDivider />
                  </>
                )}
              {props?.job?.job?.status === 0 && (
                <>
                  <HorizontalDivider />
                  <MenuItem
                    onClick={() => {
                      delete_job({
                        variables: {
                          input: {ids: [props?.job?.job?.id]}
                        }
                      });
                      handleClose();
                    }}
                  >
                    <img
                      src={images.delete_icon_red}
                      width={16}
                      style={{ marginRight: "12px" }}
                    />
                    Delete
                  </MenuItem>
                </>
              )}
            </Menu>
          </Box>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item>
          <Grid container spacing={1} alignItems="center" sx={{ mt: 2 }}>
            {(props?.job?.job?.city?.name || props?.job?.job?.state?.name) && (
              <Grid item sx={{ mr: 2, display: "flex" }}>
                <img src={images.student_location_icon_blue} height={16} />
                <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                  {(props?.job?.job?.city?.name && props?.job?.job?.state?.name) ? `${props?.job?.job?.city?.name}, ${props?.job?.job?.state?.name}` : (props?.job?.job?.state?.name || props?.job?.job?.city?.name)}
                </Typography>
              </Grid>
            )}
            <Grid item sx={{ mr: 2, display: "flex" }}>
              <img src={images.student_positions_icon_blue} height={16} />
              <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                {props?.job?.job?.positions} Positions
              </Typography>
            </Grid>
            <Grid item sx={{ mr: 2, display: "flex" }}>
              <img src={images.student_experience_icon_blue} height={14} />
              {props?.job?.job?.minimum_experience !== null &&
              props?.job?.job?.maximum_experience !== null ? (
                <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                  {props?.job?.job?.minimum_experience
                    ? props?.job?.job?.minimum_experience
                    : ""}{" "}
                  to{" "}
                  {props?.job?.job?.maximum_experience
                    ? props?.job?.job?.maximum_experience
                    : ""}{" "}
                  years
                </Typography>
              ) : (
                <Typography color={colors.fontLight} fontSize="13px" ml={0.5}>
                  Not specified
                </Typography>
              )}
            </Grid>
            <Grid item sx={{ mr: 2, display: "flex" }}>
              <img src={images.student_rupee_icon_blue} height={16} />
              {props?.job?.job?.salary_confidential ? (
                <Typography color={colors.fontLight} fontSize="13px" ml={0.5}>
                  ****
                </Typography>
              ) : props?.job?.job?.stipend_type === "fixed" ? (
                <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                  ₹
                  {props?.job?.job?.minimum_remuneration
                    ? props?.job?.job?.minimum_remuneration
                    : "*"}
                </Typography>
              ) : props?.job?.job?.stipend_type === "noStipend" ? (
                <Typography color={colors.fontLight} fontSize="13px" ml={0.5}>
                  No Stipend
                </Typography>
              ) : (
                <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                  ₹{" "}
                  {props?.job?.job?.minimum_remuneration
                    ? props?.job?.job?.minimum_remuneration
                    : "*"}{" "}
                  to ₹{" "}
                  {props?.job?.job?.maximum_remuneration
                    ? props?.job?.job?.maximum_remuneration
                    : "*"}
                </Typography>
              )}
            </Grid>
            <Grid item sx={{ display: "flex" }}>
              <img src={images.student_education_icon_blue} height={14} />
              <Typography color={colors.primaryBlue} fontSize="13px" ml={0.5}>
                {props?.job?.job?.qualification?.name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default JobInfo;
